if (typeof VideoPopup !== "function") {
  class VideoPopup extends HTMLElement {
    constructor() {
      super();

      const container = this.querySelector(".video-popup__container");
      const pauseIcon = this.querySelector(".video-popup__pause");
      const playIcon = this.querySelector(".video-popup__play");
      const overlay = this.querySelector(".video-overlay");
      const video_block = this.querySelector('video');

      container.addEventListener("mouseenter", (e) => {
        const media = this.closest("[data-video]");
        media.style = "cursor: pointer;";
      });

      // container.addEventListener("click", (e) => {
      //   const media = this.closest("[data-video]");   
      //   if (this.classList.contains("video-playing")) {
      //     this._playMedia(media);
      //     // playIcon.style.display = "none";
      //     // pauseIcon.style.display = "none";
      //     // overlay.style.display = "none";
      //     this.classList.remove("video-playing");
      //   } else {
      //     this._pauseMedia(media);
      //     // playIcon.style.display = "block";
      //     // pauseIcon.style.display = "block";
      //     // overlay.style.display = "block";
      //     this.classList.add("video-playing");
      //   }
      // });

      container.addEventListener("click", (e) => {
        const media = this.closest("[data-video]");   
        const videoElement = media.querySelector("video");
        if (videoElement) {
          if (this.classList.contains("video-playing")) {
            this._pauseMedia(media);
            // playIcon.style.display = "block";
            // pauseIcon.style.display = "none";
            overlay.style.display = "block";
            this.classList.remove("video-playing");
          } else {
            this._playMedia(media);
            // playIcon.style.display = "none";
            // pauseIcon.style.display = "block";
            overlay.style.display = "none";
            this.classList.add("video-playing");
          }
        }
      });

      // Event listener for pause icon
      // pauseIcon.addEventListener("click", (e) => {
      //   e.stopPropagation();
      //   const media = this.closest("[data-video]");
      //   if (media) {
      //     this._playMedia(media);
      //     // playIcon.style.display = "none";
      //     // pauseIcon.style.display = "none";
      //     // overlay.style.display = "none";
      //     this.classList.remove("video-playing");
      //   }
      // });

      const videoElement = this.querySelector("video");
      if (videoElement) {
        videoElement.muted = true;
      }

      // const observer = new IntersectionObserver((entries) => {
      //   entries.forEach((entry) => {
      //     const media = this.closest("[daa-video]"); 

      //     if (entry.isIntersecting) {
      //       // videoElement.play();
      //       this._playMedia(media);
      //       playIcon.style.display = "none";
      //       pauseIcon.style.display = "none";
      //       overlay.style.display = "none";
      //       this.classList.remove("video-playing");
            
      //     } else {
      //       // videoElement.pause();
      //       this._pauseMedia(media);
      //       playIcon.style.display = "block";
      //       pauseIcon.style.display = "block";
      //       overlay.style.display = "block";
      //       this.classList.add("video-playing");
      //     }
      //   });
      // }, { threshold: 0.5 });

      // observer.observe(this);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const media = this.closest("[data-video]");
          if (!window.matchMedia('(min-width: 1024px)').matches) return;
          if (entry.isIntersecting) {
            this._playMedia(media);
            this.classList.add("video-playing");
          } else {
            this._pauseMedia(media);
            this.classList.remove("video-playing");
          }
        });
      }, { threshold: 0.5 });
      
      observer.observe(this);

      this.querySelector("[data-js-video-popup-link]").addEventListener(
        "click",
        (e) => {
          e.preventDefault();

          // const blackout = document.createElement("div");
          // blackout.classList.add("video-popup__blackout");
          // this.append(blackout);
          // setTimeout(() => {
          //   blackout.style.opacity = "1";
          // }, 10);

          this.classList.add("video-opened");
          this.classList.add("video-playing");

          // if (this.querySelector("[data-js-video-popup-close]")) {
          //   this.querySelector("[data-js-video-popup-close]").addEventListener(
          //     "click",
          //     (e) => {
          //       this.querySelectorAll("iframe, video").forEach((elm) => {
          //         elm.remove();
          //       });
          //       blackout.remove();
          //       this.classList.remove("video-opened");
          //     }
          //   );
          // }

          setTimeout(() => {
            if (!this.querySelector('video, iframe')) {
              this.querySelector("[data-js-video-popup-container]").appendChild(
                this.querySelector("template").content.firstElementChild.cloneNode(true)
              );
            }
            setTimeout(() => {
              this._playMedia(this.closest("[data-video]"));
            }, 500);
          }, 50);
        }
      );
    }

    _playMedia(media) {
      switch (media.dataset.productMediaType) {
        case "video":
          const videoElement = media.querySelector("video");
          if (videoElement) {
            videoElement.loop = true;
            videoElement.muted = true;
            videoElement.play().catch(() => {});
          }
          break;
        case "external_video-youtube":
          const youtubeIframe = media.querySelector(".js-youtube");
          if (youtubeIframe) {
            youtubeIframe.contentWindow.postMessage(
              '{"event":"command","func":"' + "playVideo" + '","args":""}',
              "*"
            );
          }
          break;
        case "external_video-vimeo":
          const vimeoIframe = media.querySelector(".js-vimeo");
          if (vimeoIframe) {
            vimeoIframe.contentWindow.postMessage('{"method":"play"}', "*");
          }
          break;
      }
    }

    _pauseMedia(media) {
      switch (media.dataset.productMediaType) {
        case "video":
          if (media.querySelector("video")) {
            media.querySelector("video").pause();
          }
          break;
        case "external_video-youtube":
          if (media.querySelector(".js-youtube")) {
            media
              .querySelector(".js-youtube")
              .contentWindow.postMessage(
                '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                "*"
              );
          }
          break;
        case "external_video-vimeo":
          if (media.querySelector(".js-vimeo")) {
            media
              .querySelector(".js-vimeo")
              .contentWindow.postMessage('{"method":"pause"}', "*");
          }
          break;
      }
    }
  }

  if (typeof customElements.get("video-popup") == "undefined") {
    customElements.define("video-popup", VideoPopup);
  }
}
